/**
 * Resolves the subdomain label used for CustomBranding Firestore lookups
 * (`${label}.${SECRETS_ENV.DOMAIN}`), including multitenancy hosts:
 * - `coach.tenant.…` → `tenant`
 * - `www.coach.tenant.…` → `tenant`
 * Otherwise preserves existing behavior (`tenant.…` or `www.tenant.…` → `tenant`).
 */
export function getCustomBrandingSubdomainFromHost(host: string): string | undefined {
  const hostname = host.split(":")[0];
  const arr = hostname.split(".");
  if (arr.length === 0) return undefined;

  if (arr[0] === "www") {
    if (arr[1] === "coach" && arr.length > 3) {
      return arr[2];
    }
    if (arr.length > 1) {
      return arr[1];
    }
    return undefined;
  }

  if (arr[0] === "coach" && arr.length > 2) {
    return arr[1];
  }

  return arr[0];
}
